import { Routes } from '@angular/router';
import { DefineComponent } from './pages/define/define.component';
import { CompanyFitComponent } from './pages/define/company-fit/company-fit.component';
import { ValueAnalysisComponent } from './pages/define/value-analysis/value-analysis.component';
import { DemoAndProofsComponent } from './pages/define/demo-and-proofs/demo-and-proofs.component';
import { SpacesComponent } from './pages/spaces/spaces.component';
import { SpaceDetailComponent } from './pages/space-detail/space-detail.component';
import { SpaceCompanyFitComponent } from './pages/space-detail/company-fit/company-fit.component';
import { SpaceValueAnalysisComponent } from './pages/space-detail/value-analysis/value-analysis.component';
import { SpaceDemoAndProofsComponent } from './pages/space-detail/demo-and-proofs/demo-and-proofs.component';
import { ImportSpaceComponent } from './pages/import-space/import-space.component';
import { LandingComponent } from './pages/landing/landing.component';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'landing', component: LandingComponent },
  { path: 'callback', redirectTo: '/landing', pathMatch: 'full' },
  {
    path: 'define',
    component: DefineComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'company-fit', pathMatch: 'full' },
      { path: 'company-fit', component: CompanyFitComponent },
      { path: 'value-analysis', component: ValueAnalysisComponent },
      { path: 'demo-and-proofs', component: DemoAndProofsComponent }
    ]
  },
  { path: 'spaces', component: SpacesComponent, canActivate: [authGuard] },
  { path: 'spaces/import', component: ImportSpaceComponent, canActivate: [authGuard] },
  {
    path: 'spaces/:spaceId',
    component: SpaceDetailComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'company-fit', pathMatch: 'full' },
      { path: 'company-fit', component: SpaceCompanyFitComponent },
      { path: 'value-analysis', component: SpaceValueAnalysisComponent },
      { path: 'demo-and-proofs', component: SpaceDemoAndProofsComponent }
    ]
  }
];
